import { render, staticRenderFns } from "./BlogArticleViewMobile.vue?vue&type=template&id=271d1782&scoped=true"
import script from "./BlogArticleViewMobile.vue?vue&type=script&lang=js"
export * from "./BlogArticleViewMobile.vue?vue&type=script&lang=js"
import style0 from "./BlogArticleViewMobile.vue?vue&type=style&index=0&id=271d1782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d1782",
  null
  
)

export default component.exports